import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-messaging',
  templateUrl: './admin-messaging.component.html',
  styleUrls: ['./admin-messaging.component.scss'],
})
export class AdminMessagingComponent {
  constructor() {}
}
